<template>
  <div class="newspaperInfoList">
    <div class="filters">
      <el-form :inline="true">
        <!-- 时间 -->
        <el-form-item>
          <el-date-picker v-model="datevalues" type="daterange" :range-separator="$t('lang.lab_to')"
            :start-placeholder="$t('lang.lab_startDate')" :end-placeholder="$t('lang.lab_endDate')"
            value-format="timestamp"></el-date-picker>
        </el-form-item>
        <!-- 请选择小区 -->
        <el-form-item>
          <el-select class="w220" v-model="value" multiple collapse-tags filterable placeholder="请选择项目">
            <el-option v-for="(item,index) in gardens" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 报事分类一级 -->
        <el-form-item>
          <el-select v-model="firstLevelid">
            <el-option key :label="$t('lang.lab_firstLevel')" value="0"></el-option>
            <el-option v-for="(item,index) in firstLevellist" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 工单状态 -->
        <el-form-item>
          <el-select v-model="state">
            <el-option key :label="$t('lang.lab_orderstate')" value="0"></el-option>
            <el-option v-for="(item,index) in statelist" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <!-- 是否审阅：报事信息 -->
        <el-form-item>
          <el-select v-model="isCheck" multiple collapse-tags placeholder="请选择问题类型">
            <el-option label="审阅不合格" :value=1></el-option>
            <el-option label="抽审不合格" :value=2></el-option>
          </el-select>
        </el-form-item>
        <!-- 提交button -->
        <el-button type="primary" @click="commit">{{$t('lang.btn_search')}}</el-button>
        <div style="display: inline-block;">
          <el-select v-model="customColVal" @change="storageCustomColVal" multiple collapse-tags
            style="margin-left: 20px;width: 220px;" placeholder="请选择">
            <el-option v-for="item in customColList" :key="item.value" :label="item.label" :value="item.value"
              :disabled="item.disabled">
            </el-option>
          </el-select>
          <el-tooltip class="item" effect="light" content='为了您更方便的查看表格数据，您可自定义选择需要展示的数据' placement="right">
            <el-button class="noStyle"><i class="el-icon-warning-outline tipIcon"></i></el-button>
          </el-tooltip>
        </div>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      <el-table
        :height="tableData.length > 0 ? require('@/config/enum').tableheight539 : require('@/config/enum').tableheight119"
        :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="this.NewspaperInfoListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <!-- id -->
        <el-table-column prop="id" :label="$t('lang.lab_Id')" width="100px"></el-table-column>
        <!-- 报事用户 -->
        <el-table-column :label="$t('lang.lab_paperusername')" width="200px">
          <template slot-scope="scope">
            <div v-if="scope.row.user">
              <el-tooltip placement="top" effect="light"
                v-if="scope.row.user.nickName&&scope.row.user.nickName.length> 20" :disabled="false">
                <div slot="content">
                  <span>{{ scope.row.user.nickName }}</span>
                </div>
                <div>
                  {{ scope.row.user.nickName.substring(0, 10) | valueIsNull }}
                  <span v-if="scope.row.user.nickName.length>10">...</span>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" effect="light" v-else :disabled="true">
                <div>{{ scope.row.user.nickName | valueIsNull }}</div>
              </el-tooltip>
            </div>
            <div v-else>
              <el-tooltip placement="top" effect="light" v-if="scope.row.userName&&scope.row.userName.length> 10"
                :disabled="false">
                <div slot="content">
                  <span>{{ scope.row.userName }}</span>
                </div>
                <div>
                  {{ scope.row.userName.substring(0, 10) | valueIsNull }}
                  <span v-if="scope.row.userName.length>10">...</span>
                </div>
              </el-tooltip>
              <el-tooltip placement="top" effect="light" v-else :disabled="true">
                <div>{{ scope.row.userName | valueIsNull }}</div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
        <!-- 小区 -->
        <el-table-column :label="$t('lang.lab_papergarden')" width="100px">
          <template slot-scope="scope">{{ scope.row.garden.name}}</template>
        </el-table-column>
        <!-- 报事方式 -->
        <el-table-column :label="$t('lang.lab_mainSource')" width="150px" v-if="customColVal.includes('报事来源')">
          <template slot="header">
            {{ $t('lang.lab_mainSource') }}
            <el-tooltip effect="light" placement="top">
              <i class="el-icon-question" style="margin-left:4px;color:#909399;cursor:help"></i>
              <div slot="content">红色代表巡检标准存在异常</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <!-- 后台报事 -->
            <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId === 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperlast')}}</span>
            <!-- GBA设备报事 -->
            <span v-if="scope.row.beginSource === 5"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperGBA')}}</span>
            <!-- 自动巡检工单 -->
            <span v-if="scope.row.beginSource === 1 && scope.row.quartzJobId > 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperauto')}}</span>
            <!-- 业主APP报事 -->
            <span v-if="scope.row.beginSource === 2"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperownerapp')}}</span>
            <!-- 物业APP报事 -->
            <span v-if="scope.row.beginSource === 3 && scope.row.quartzJobId == 0"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperPropertyapp')}}</span>
            <!-- 看板报事 -->
            <span v-if="scope.row.beginSource === 6"
              :style="{color:scope.row.isErr===1?'red':''}">{{$t('lang.lab_paperBoard')}}</span>
            <!-- 400后台补单 -->
            <span v-if="scope.row.beginSource == 4 && scope.row.quartzJobId == 0">{{$t('lang.lab_addback')}}</span>
          </template>
        </el-table-column>
        <!-- 审阅状态 -->
        <el-table-column v-if="customColVal.includes('审阅状态')" label="审阅状态" width="200px" prop="isCheck">
          <template slot-scope="scope">
            <!-- 未审阅 -->
            <span v-if="scope.row.isCheck === 0" :title="$t('lang.lab_isCheck1')" class="isCheck0style">未审阅</span>
            <!-- 审阅合格 -->
            <span v-if="scope.row.isCheck === 1" :title="$t('lang.lab_isCheck1')"
              class="isCheck1style">{{$t('lang.lab_isCheck1Abbr')}}</span>
            <!-- 审阅不合格 -->
            <span v-if="scope.row.isCheck === 2" :title="$t('lang.lab_isCheck2')"
              class="isCheck2style">{{$t('lang.lab_isCheck2Abbr')}}</span>
            <!-- 审阅优秀 -->
            <span v-if="scope.row.isCheck === 4" :title="$t('lang.lab_isCheck2')" class="isCheck1style">优秀</span>
          </template>
        </el-table-column>
        <!-- 抽审状态 -->
        <el-table-column v-if="customColVal.includes('抽审状态')" label="抽审状态" width="200px" prop="randomState">
          <template slot-scope="scope">
            <!-- 抽审合格 -->
            <span v-if="scope.row.randomState == null" :title="$t('lang.lab_isCheck1')" class="isCheck0style">未抽审</span>
            <!-- 抽审合格 -->
            <span v-if="scope.row.randomState == 1" :title="$t('lang.lab_isCheck1')" class="isCheck0style">待抽审</span>
            <!-- 抽审不合格 -->
            <span v-if="scope.row.randomState == 2" :title="$t('lang.lab_isCheck2')" class="isCheck1style">合格</span>
            <!-- 抽审不合格 -->
            <span v-if="scope.row.randomState == 3" :title="$t('lang.lab_isCheck2')" class="isCheck2style">不合格</span>
            <!-- 抽审不合格 -->
            <span v-if="scope.row.randomState == 4" :title="$t('lang.lab_isCheck2')" class="isCheck1style">优秀</span>
          </template>
        </el-table-column>
        <!-- 报事时间 -->
        <el-table-column :label="$t('lang.lab_papertime')" width="200px" v-if="customColVal.includes('报事时间')"
          prop="createTime" sortable>
          <template slot="header">
            {{ $t('lang.lab_papertime') }}
            <el-tooltip effect="light" placement="top">
              <i class="el-icon-question" style="margin-left:4px;color:#909399;cursor:help"></i>
              <div slot="content">红色代表工单超时</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <span v-if="scope.row.isOvertime === 1" class="red">{{scope.row.createTime | time}}</span>
            <span v-else>{{scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
        <!-- 结束时间 -->
        <el-table-column v-if="customColVal.includes('结束时间')" label="结束时间" width="200px" prop="endDate" sortable>
          <template slot-scope="scope">
            <span>{{scope.row.endDate | time}}</span>
          </template>
        </el-table-column>
        <!-- 楼号 -->
        <el-table-column :label="$t('lang.lab_paperhouse')" width="100px" v-if="customColVal.includes('楼号')">
          <template slot-scope="scope" v-if="scope&&scope.row.garden.grids">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.garden.grids.houseName&&scope.row.garden.grids.houseName.length> 5" :disabled="false">
              <div slot="content">
                <span>{{ scope.row.garden.grids.houseName }}</span>
              </div>
              <div>
                {{ scope.row.garden.grids.houseName.substring(0, 5) | valueIsNull }}
                <span v-if="scope.row.garden.grids.houseName.length>5">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.garden.grids.houseName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 单元号 -->
        <el-table-column :label="$t('lang.lab_paperunit')" width="100px" v-if="customColVal.includes('单元号')">
          <template slot-scope="scope" v-if="scope&&scope.row.garden.grids">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.garden.grids.unitName&&scope.row.garden.grids.unitName.length> 5" :disabled="false">
              <div slot="content">
                <span>{{ scope.row.garden.grids.unitName }}</span>
              </div>
              <div>
                {{ scope.row.garden.grids.unitName.substring(0, 5) | valueIsNull }}
                <span v-if="scope.row.garden.grids.unitName.length>5">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.garden.grids.unitName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 房间号 -->
        <el-table-column :label="$t('lang.lab_paperroom')" width="100px" v-if="customColVal.includes('房间号')">
          <template slot-scope="scope" v-if="scope&&scope.row.garden.grids">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.garden.grids.roomName&&scope.row.garden.grids.roomName.length> 5" :disabled="false">
              <div slot="content">
                <span>{{ scope.row.garden.grids.roomName }}</span>
              </div>
              <div>
                {{ scope.row.garden.grids.roomName.substring(0, 5) | valueIsNull }}
                <span v-if="scope.row.garden.grids.roomName.length>5">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.garden.grids.roomName | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 报事类型 -->
        <el-table-column :label="$t('lang.lab_papertypes')" width="150px" v-if="customColVal.includes('报事类型')">
          <template slot-scope="scope" v-if="scope&&scope.row.maintainType1">{{scope.row.maintainType1.name}}</template>
        </el-table-column>
        <el-table-column label="报事类型II" width="150px" v-if="customColVal.includes('报事类型II')">
          <template slot-scope="scope" v-if="scope&&scope.row.maintainType2">{{scope.row.maintainType2.name}}</template>
        </el-table-column>
        <el-table-column label="报事类型III" width="150px" v-if="customColVal.includes('报事类型III')">
          <template slot-scope="scope" v-if="scope&&scope.row.maintainType3">{{scope.row.maintainType3.name}}</template>
        </el-table-column>
        <el-table-column label="报事类型Ⅳ" width="150px" v-if="customColVal.includes('报事类型Ⅳ')">
          <template slot-scope="scope" v-if="scope&&scope.row.maintainType4">{{scope.row.maintainType4.name}}</template>
        </el-table-column>
        <!-- 事件性质-->
        <el-table-column :label="$t('lang.lab_papernatureofaffairs')" v-if="customColVal.includes('事件性质')">
          <template slot-scope="scope">
            <!-- 0: 事件性质 -->
            <span v-if="scope.row.complainFlag === 0">{{$t('lang.lab_papereno')}}</span>
            <!-- 1: 咨询 -->
            <span v-if="scope.row.complainFlag === 1">{{$t('lang.lab_papereconsult')}}</span>
            <!-- 2: 投诉 -->
            <span v-if="scope.row.complainFlag === 2">{{$t('lang.lab_paperecomplaint')}}</span>
            <!-- 3: 表扬 -->
            <span v-if="scope.row.complainFlag === 3">{{$t('lang.lab_paperecommend')}}</span>
          </template>
        </el-table-column>
        <!-- 事件类别 -->
        <el-table-column :label="$t('lang.lab_complainFlagofType')" v-if="customColVal.includes('事件类别')">
          <template slot-scope="scope">
            <!-- 0: 事件性质 -->
            <span v-if="scope.row.complainFlag === 0">{{$t('lang.lab_papereno')}}</span>
            <!-- 1: 咨询 -->
            <span v-if="scope.row.complainFlag === 1">{{$t('lang.lab_papereconsult')}}</span>
            <!-- 2: 投诉 -->
            <span v-if="scope.row.complainFlag === 2">{{$t('lang.lab_paperecomplaint')}}</span>
            <!-- 3: 表扬 -->
            <span v-if="scope.row.complainFlag === 3">{{$t('lang.lab_paperecommend')}}</span>
          </template>
        </el-table-column>
        <!-- 工单属性 -->
        <el-table-column width="160px" :label="$t('lang.lab_papereProperty')" v-if="customColVal.includes('工单属性')">
          <template slot-scope="scope">
            <!-- 未接单 -->
            <span v-if="scope.row.property === 0" :title="$t('lang.lab_property0')"
              class="property0style">{{$t('lang.lab_property0Abbr')}}</span>
            <!-- 我已接的工单 -->
            <span v-if="scope.row.property === 1" :title="$t('lang.lab_property1')"
              class="property1style">{{$t('lang.lab_property1Abbr')}}</span>
            <!-- 派给我的工单 -->
            <span v-if="scope.row.property === 2" :title="$t('lang.lab_property2')"
              class="property2style">{{$t('lang.lab_property2Abbr')}}</span>
            <!-- 我发起的工单 -->
            <span v-if="scope.row.property === 3" :title="$t('lang.lab_property3')"
              class="property3style">{{$t('lang.lab_property3Abbr')}}</span>
            <!-- Ta人的工单 -->
            <span v-if="scope.row.property === 4" :title="$t('lang.lab_property4')"
              class="property4style">{{$t('lang.lab_property4Abbr')}}</span>
            <!-- 超时的工单 -->
            <span v-if="scope.row.isOvertime === 1" :title="$t('lang.lab_isOvertime1')"
              class="isOvertime1style">{{$t('lang.lab_isOvertime1Abbr')}}</span>
            <!-- 关闭的工单：正常关闭 -->
            <span v-if="scope.row.state === 5" :title="$t('lang.lab_state5_1')"
              class="state5style">{{$t('lang.lab_state5Abbr_1')}}</span>
            <!-- 关闭的工单：非正常关闭 -->
            <span v-if="scope.row.state === 6" :title="$t('lang.lab_state6_1')"
              class="state6style">{{$t('lang.lab_state6Abbr_1')}}</span>
            <!-- 已回访的工单 -->
            <span v-if="scope.row.isFollow === 2" :title="$t('lang.lab_isFollow2')"
              class="isFollow2style">{{$t('lang.lab_isFollow2Abbr')}}</span>
            <!-- 子工单 -->
            <span v-if="scope.row.haveChild === 1" :title="$t('lang.lab_haveChild1')" class="haveChild1style"
              @click="haveChildId(scope.row.id)">{{$t('lang.lab_haveChild1Abbr')}}</span>
            <!-- 父工单 -->
            <span v-if="scope.row.parentId" :title="$t('lang.lab_haveParentId')" class="haveParentIdstyle"
              @click="detail(scope.row.parentId)">{{$t('lang.lab_haveParentIdAbbr')}}</span>
            <!-- 代客报事 -->
            <span v-if="scope.row.isValet === 1" :title="$t('lang.lab_isValet1')"
              class="isValet1style">{{$t('lang.lab_isValet1Abbr')}}</span>
            <!-- 稽查报事 -->
            <span v-if="scope.row.isInspect === 1" :title="$t('lang.lab_isInspect1')"
              class="isInspect1style">{{$t('lang.lab_isInspect1Abbr')}}</span>
            <!-- 抄送给我的工单 -->
            <span v-if="scope.row.isCopyToMe === 1" :title="$t('lang.lab_isCopyToMe1')"
              class="isCopyToMe1style">{{$t('lang.lab_isCopyToMe1Abbr')}}</span>
          </template>
        </el-table-column>
        <!-- 工单状态 -->
        <el-table-column sortable prop="state" width="120px" :label="$t('lang.lab_paperestate')"
          v-if="customColVal.includes('工单状态')">
          <template slot-scope="scope">
            <!-- 0: 报事状态 -->
            <span v-if="scope.row.state === 0">{{$t('lang.lab_paperereportingstate')}}</span>
            <!-- 1: 待确认 -->
            <span v-if="scope.row.state === 1" class="red">{{$t('lang.lab_papereconfirmed')}}</span>
            <!-- 2: 处理中 -->
            <span v-if="scope.row.state === 2" class="blue">{{$t('lang.lab_paperesolved')}}</span>
            <!-- 3: 已完成 -->
            <span v-if="scope.row.state === 3">{{$t('lang.lab_paperefinsh')}}</span>
            <!-- 4: 已评价 -->
            <span v-if="scope.row.state === 4 && scope.row.isFollow === 2"
              class="green">{{$t('lang.lab_paperealreadyevaluated')}}</span>
            <!-- 4: 已评价 -->
            <span
              v-if="scope.row.state === 4 && scope.row.isFollow != 2">{{$t('lang.lab_paperealreadyevaluated')}}</span>
            <!-- 5: 正常关闭 -->
            <span v-if="scope.row.state === 5">{{$t('lang.lab_paperecloses')}}</span>
            <!-- 6: 非正常关闭 -->
            <span v-if="scope.row.state === 6">{{$t('lang.lab_paperenoclose')}}</span>
            <!-- 7: 已撤销 -->
            <span v-if="scope.row.state === 7">已撤销</span>
            <!-- 8: 已关闭（挂起） -->
            <span v-if="scope.row.state === 8">已关闭（挂起）</span>
          </template>
        </el-table-column>
        <!-- 接单人 -->
        <el-table-column :label="$t('lang.lab_paperpeople')" width="250px" v-if="customColVal.includes('接单人')">
          <template slot-scope="scope" v-if="scope.row.staffId!= 0&&scope.row.staff!=null&&scope.row.staff.idNo">
            <el-tooltip placement="top" effect="light" v-if="scope.row.staff.idNo&&scope.row.staff.idNo.length> 20"
              :disabled="false">
              <div slot="content">
                <span>{{ scope.row.staff.idNo }}</span>
              </div>
              <div>
                {{ scope.row.staff.idNo.substring(0, 10) | valueIsNull }}
                <span v-if="scope.row.staff.idNo.length>10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.staff.idNo | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 内容 -->
        <el-table-column :label="$t('lang.lab_papercontent')" prop="content" width="210px"
          v-if="customColVal.includes('内容')">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light"
              v-if="scope.row.content&&scope.row.content.length> require('@/config/enum').tableDatamaxlength10"
              :disabled="false">
              <div slot="content">
                <span>{{ scope.row.content }}</span>
              </div>
              <div class="conctentstyle">
                {{ scope.row.content.substring(0, require('@/config/enum').tableDatamaxlength10) | valueIsNull }}
                <span v-if="scope.row.content.length>require('@/config/enum').tableDatamaxlength10">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div class="conctentstyle">{{ scope.row.content | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- 满意度 -->
        <el-table-column :label="$t('lang.lab_paperevaluate')" prop="evaluate" sortable width="100px"
          v-if="customColVal.includes('满意度')">
          <template slot-scope="scope">
            <span v-if="scope.row.evaluate === 3" class="red">{{$t('lang.lab_paperenovaluate')}}</span>
            <span v-if="scope.row.evaluate === 0">{{$t('lang.lab_paperevaluateres')}}</span>
            <span v-if="scope.row.evaluate === 1">{{$t('lang.lab_paperevaluateyes')}}</span>
            <span v-if="scope.row.evaluate === 2">{{$t('lang.lab_paperevaluatesoso')}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="gardenGridName" :label="$t('lang.lab_housekeeper')" v-if="customColVal.includes('管家')" width="250px">
        </el-table-column>
        <!-- 已完成数量/异常数量/总数量 -->
        <el-table-column width="150px" :label="$t('lang.lab_stateCount')"
          v-if="customColVal.includes('已完成/异常/已跳过/总数量')">
          <template slot-scope="scope">
            <span>{{scope.row.finishStateCount}}/{{scope.row.errorStateCount}}/{{scope.row.missStateCount}}/{{scope.row.allStateCount}}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column align="center" :label="$t('lang.lab_operation')" prop="operation" fixed="right" :width="180">
          <template slot-scope="scope" align="center">
            <el-button v-contextmenu:contextmenu class="operation" @click="detail(scope.row.id,scope.row.haveChild)">
              {{$t('lang.btn_detail')}}</el-button>
            <v-contextmenu ref="contextmenu">
              <v-contextmenu-item @click="jumpNewLink(scope.row.id,scope.row.haveChild)">在新标签页打开链接</v-contextmenu-item>
            </v-contextmenu>
            <el-button class="operation" @click="showPhotos(scope.row.id)">{{$t('lang.lab_photodetail')}}</el-button>
            <el-button class="operation" v-if="isSetUp===1" @click="showSetting(scope.row)">{{$t('lang.lab_setBtn')}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
        :page-sizes="[10, 20, 30, 50,100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
    <el-dialog :visible.sync="show" :close-on-click-modal="false" center top="130px" width="800px"
      :title="$t('lang.lab_quesPicture')">
      <!-- 照片 -->
      <el-form>
        <el-form-item :label="$t('lang.lab_backgroundfilesBefore')">
          <viewer v-if="uris !=''" :images="uris.split(',')" class="img-width">
            <img v-for="(src,index) in uris.split(',')" :src="src" :key="index" class="img">
          </viewer>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_backgroundfilesAfter')">
          <viewer v-if="uris_af !=''" :images="uris_af.split(',')" class="img-width">
            <img v-for="(src,index) in uris_af.split(',')" :src="src" :key="index" class="img">
          </viewer>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 设置弹窗 -->
    <el-dialog title="工单评价等级设置" :visible.sync="settingDialogVisible" width="40%" :close-on-click-modal="false">
      <div class='gradeRadio'>
        <span class='gradeRadioLabel'>工单评价等级：</span>
        <el-radio class='gradeRadioValue' v-model="gradeRadio" label="1">优</el-radio>
        <el-radio class='gradeRadioValue' v-model="gradeRadio" label="2">良</el-radio>
        <el-radio class='gradeRadioValue' v-model="gradeRadio" label="0">无</el-radio>
      </div>
      <div class='gradeRemarkBox'>
        <span class='gradeStar'>*</span>
        <el-input class='gradeRemark' type="textarea" :rows="4" placeholder="选择优良时,请输入工单等级评价批注（必填）"
          v-model="gradeRemark">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="settingCancel">取 消</el-button>
        <el-button type="primary" @click="settingConfim">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  // 引入富文本title汉字
  import {
    excelDownload
  } from '../../../config/download.js'
  import {
    mapGetters
  } from 'vuex'
  export default {
    data() {
      return {
        customColList: [{
            value: 'ID',
            label: 'ID',
            disabled: true
          },
          {
            value: '报事用户',
            label: '报事用户',
            disabled: true
          },
          {
            value: '小区',
            label: '小区',
            disabled: true
          },
          {
            value: '报事来源',
            label: '报事来源'
          },
          {
            value: '报事时间',
            label: '报事时间'
          },
          {
            value: '结束时间',
            label: '结束时间'
          },
          {
            value: '审阅状态',
            label: '审阅状态'
          },
          {
            value: '抽审状态',
            label: '抽审状态'
          },
          {
            value: '楼号',
            label: '楼号'
          },
          {
            value: '单元号',
            label: '单元号'
          },
          {
            value: '房间号',
            label: '房间号'
          },
          {
            value: '报事类型',
            label: '报事类型'
          },
          {
            value: '报事类型II',
            label: '报事类型II'
          },
          {
            value: '报事类型III',
            label: '报事类型III'
          },
          {
            value: '报事类型Ⅳ',
            label: '报事类型Ⅳ'
          },
          {
            value: '事件类别',
            label: '事件类别'
          },
          {
            value: '事件性质',
            label: '事件性质'
          },
          {
            value: '工单属性',
            label: '工单属性'
          },
          {
            value: '工单状态',
            label: '工单状态'
          },
          {
            value: '接单人',
            label: '接单人'
          },
          {
            value: '内容',
            label: '内容'
          },
          {
            value: '满意度',
            label: '满意度'
          },
          {
            value: '管家',
            label: '管家'
          },
          {
            value: '已完成/异常/已跳过/总数量',
            label: '已完成/异常/已跳过/总数量'
          },
        ], // 自定义展示列数据
        customColVal: ['ID', '报事用户', '小区', '报事来源', '报事时间', '结束时间', '审阅状态', '抽审状态', '楼号', '单元号', '房间号', '报事类型', '报事类型II',
          '报事类型III', '报事类型Ⅳ', '事件类别', '事件性质', '工单属性', '工单状态', '接单人', '内容', '满意度', '管家', '已完成/异常/已跳过/总数量'
        ], // 自定义展示列val
        handleType: '',
        childId: '',
        diff: false, // 账号权限小区
        multipleSelection: [], // 多选框
        hasComplain: '', // 接口参数，目前不知道啥用
        complainFlag2: '', // 接口参数，目前不知道啥用
        isQuartzJob: '', // 接口参数，目前不知道啥用
        datevalues: [new Date().getTime() - (30 * 24 * 60 * 60 * 1000), new Date().getTime()], // 开始结束时间绑定值
        workorderlist: this.$i18n.t('lang.NewspaperInfoList.workorderlist'), // 工单完结list
        isEndCondition: '', // 工单完结绑定值
        value: [], // 小区绑定值
        gardens: [], // 小区下拉列表
        floorid: '0', // 楼层绑定值
        floorList: [], // 楼层下拉列表
        unitid: '0', // 单元绑定值
        unitList: [], // 单元下拉列表
        roomid: '0', // 房间绑定值
        roomList: [], // 房间下拉列表
        patrolStandard: '', // 巡检标准绑定值
        patrolStandardList: [], // 巡检标准列表
        isOvertime: '', // 是否超时绑定值
        isOvertimelist: this.$i18n.t('lang.NewspaperInfoList.isOvertimelist'), // 是否超时list
        state: '0', // 工单状态绑定值
        statelist: this.$i18n.t('lang.NewspaperInfoList.statelist'), // 工单状态list
        evaluate: '', // 满意度绑定值
        evaluatelist: this.$i18n.t('lang.NewspaperInfoList.evaluatelist'), // 满意度list
        complainFlag: '', // 事件性质绑定值
        complainFlaglist: this.$i18n.t('lang.NewspaperInfoList.complainFlaglist'), // 事件性质list
        refresh: '2', // 开启关闭自动刷新绑定值
        refreshs: this.$i18n.t('lang.NewspaperInfoList.refreshs'), // 开启关闭自动刷新list
        propertyStatus: '', // 处理状态绑定值
        propertyStatusList: this.$i18n.t('lang.MaintainsList.propertyStatusList'), // 处理状态list
        hasPic: '', // 是否有图绑定值
        hasPicList: this.$i18n.t('lang.MaintainsList.hasPicList'), // 是否有图list
        mainSource: '', // 报事来源绑定值
        mainSourceList: this.$i18n.t('lang.MaintainsList.mainSourceList'), // 报事来源list
        isInTime: '', // 是否24小时绑定值
        isInTimeList: this.$i18n.t('lang.MaintainsList.isInTimeList'), // 是否24小时list
        isValet: '', // 是否代客报事绑定值
        isCheck: [], // 是否审阅绑定值
        isCheckList: this.$i18n.t('lang.MaintainsList.isCheckList'), // 是否审阅list
        isInspect: '', // 是否稽查工单绑定值
        isInspectList: this.$i18n.t('lang.MaintainsList.isInspectList'), // 是否稽查工单list
        haveParent: '', // 是否有父工单绑定值
        haveParentList: this.$i18n.t('lang.MaintainsList.haveParentList'), // 是否有父工单list
        haveChild: '', // 是否有子工单绑定值
        haveChildList: this.$i18n.t('lang.MaintainsList.haveChildList'), // 是否有子工单list
        gradeEvaluationList: this.$i18n.t('lang.MaintainsList.gradeEvaluationList'), // 工单评价等级list
        isEagleEye: '', // 是否鹰眼报事
        NewspaperInfoListcheckbox: require('@/config/enum')
          .NewspaperInfoListcheckbox, // 是否隐藏复选框
        keyword: '', // 手机或序号内容input
        staffName: '', // 接单人input
        sendName: '', // 报单人input
        pageCount: 0, // 总页数
        pageNum: 1, // 第几页
        pageSize: 10, // 每页显示数
        tableData: [], // 列表数组
        type: 1, // 楼号单元号房间号区分
        firstLevelid: '0', // 一级分类绑定id
        firstLevellist: [], // 一级分类list
        secondLevelid: '0', // 二级分类绑定id
        secondLevellist: [], // 二级分类list
        thirdLevelid: '0', // 三级分类绑定id
        thirdLevellist: [], // 三级分类list
        fourthLevelid: '0', // 四级分类绑定id
        fourthLevellist: [], // 四级分类list
        fifthLevelid: '0', // 五级分类绑定id
        fifthLevellist: [], // 五级分类list
        typeleval: 1, // 级别接口区分字段
        show: false, // 弹框开关
        editId: '', // 编辑页面的ID
        uris: '',
        uris_af: '',
        myLaunch: '', // 我发起的
        settingDialogVisible: false,
        gradeRadio: '0', // 工单评价等级
        gradeRemark: '', // 工单评价等级批注
        gradeEvaluation: '', // 工单评价等级筛选
        maintainId: '', // 工单id
        venueId: '', // 资源点位id
        checkRandomState: 0, // 审阅||抽审不合格
        checkState: '', // 审阅不合格
        randomState: '' // 抽审不合格
      }
    },
    created() {
      this.value = (this.gardenId.toString()).split(',')
      if (this.userPermission === '*' || this.gardenId === 0) {
        this.diff = false
      } else {
        this.diff = true
      }
      this.myGarden()
      // 一级别下拉
      this.maintainTypes()
      // 查询list
      this.maintains()
      // 获取缓存自定义列
      let customColVal = localStorage.getItem('customColVal')
      if (customColVal) {
        this.customColVal = customColVal.split(',')
      }
    },
    activated() {
      const haveChildParentId = sessionStorage.getItem('haveChildParentId')
      if (haveChildParentId) {
        // 调用查看子工单方法
        this.haveChildId(haveChildParentId)
        // 清除参数
        sessionStorage.removeItem('haveChildParentId')
      }
    },

    computed: {
      ...mapGetters({
        gardenId: 'gardenId',
        userPermission: 'permission',
        userDataId: 'staffId',
        isSetUp: 'isSetUp'
      })
    },
    watch: {
      gardenId: function (newFlag, oldFlag) {
        this.value = newFlag
        this.gardenGrids(newFlag)
      },
      isCheck: {
        handler(newVal) {
          // 重置状态
          this.checkRandomState = 0
          this.checkState = ''
          this.randomState = ''

          if (newVal && newVal.length > 0) {
            this.checkRandomState = 1
            // 处理多选逻辑
            newVal.forEach(val => {
              if (val === 1) {
                this.checkState = 2
              }
              if (val === 2) {
                this.randomState = 3
              }
            })
          }
        },
        immediate: true
      }
    },
    methods: {
      // 缓存自定义列
      storageCustomColVal(val) {
        console.log(val)
        localStorage.setItem('customColVal', val)
      },
      // 点击父工单(未验证)
      haveParentId(id) {
        this.$get(`maintains/${id}`).then(
          res => {
            if (res && res.errCode === 0) {
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 点击子工单(未验证)
      haveChildId(id) {
        this.childId = id
        this.$get(`maintains?parentId=${id}&pageSize=${this.pageSize}&pageNo=${this.pageNum}`).then(
          res => {
            if (res && res.errCode === 0) {
              this.handleType = 'child'
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 表格下载
      excelDownloadClick() {
        if (navigator.onLine) {
          // 对应table数据的列字段名
          let newArr = []
          let userName = ''
          let gardenName = ''
          let beginSource = ''
          let houseName = ''
          let unitName = ''
          let roomName = ''
          let maintainType1 = ''
          let maintainType2 = ''
          let maintainType3 = ''
          let maintainType4 = ''
          let complainFlag = ''
          let property = ''
          let state = ''
          let evaluate = ''
          let stateCount = ''
          if (this.tableData.length > 0) {
            for (let i = 0; i < this.tableData.length; i++) {
              // 判断报事用户是否存在
              if (this.tableData[i].user) {
                userName = this.tableData[i].user.nickName
              } else {
                userName = this.tableData[i].userName
              }
              // 判断小区楼号单元房间号是否存在
              if (this.tableData[i].garden) {
                gardenName = this.tableData[i].garden.name
              }
              if (this.tableData[i].garden.grids) {
                houseName = this.tableData[i].garden.grids.houseName
                unitName = this.tableData[i].garden.grids.unitName
                roomName = this.tableData[i].garden.grids.roomName
              }
              // 判断报事方式
              if (
                this.tableData[i].beginSource === 1 &&
                this.tableData[i].quartzJobId === 0
              ) {
                beginSource = this.$i18n.t('lang.lab_paperlast')
              } else if (
                this.tableData[i].beginSource === 1 &&
                this.tableData[i].quartzJobId > 0
              ) {
                beginSource = this.$i18n.t('lang.lab_paperauto')
              } else if (this.tableData[i].beginSource === 2) {
                beginSource = this.$i18n.t('lang.lab_paperownerapp')
              } else if (
                this.tableData[i].beginSource === 3 &&
                this.tableData[i].quartzJobId == 0
              ) {
                beginSource = this.$i18n.t('lang.lab_paperPropertyapp')
              } else if (
                this.tableData[i].beginSource === 4 &&
                this.tableData[i].quartzJobId == 0
              ) {
                beginSource = this.$i18n.t('lang.lab_addback')
              } else if (
                this.tableData[i].beginSource === 5 &&
                this.tableData[i].quartzJobId == 0
              ) {
                beginSource = this.$i18n.t('lang.lab_paperGBA')
              } else if (this.tableData[i].beginSource === 6) {
                beginSource = this.$i18n.t('lang.lab_paperBoard')
              }
              // 判断报事类型是否存在
              if (this.tableData[i].maintainType1.name) {
                maintainType1 = this.tableData[i].maintainType1.name
              }
              if (this.tableData[i].maintainType2 && this.tableData[i].maintainType2.name) {
                maintainType2 = this.tableData[i].maintainType2.name
              }
              if (this.tableData[i].maintainType3 && this.tableData[i].maintainType3.name) {
                maintainType3 = this.tableData[i].maintainType3.name
              }
              if (this.tableData[i].maintainType4 && this.tableData[i].maintainType4.name) {
                maintainType4 = this.tableData[i].maintainType4.name
              }
              // 判断事件性质，事件类别
              if (this.tableData[i].complainFlag === 0) {
                complainFlag = this.$i18n.t('lang.lab_papereno')
              } else if (this.tableData[i].complainFlag === 1) {
                complainFlag = this.$i18n.t('lang.lab_papereconsult')
              } else if (this.tableData[i].complainFlag === 2) {
                complainFlag = this.$i18n.t('lang.lab_paperecomplaint')
              } else if (this.tableData[i].complainFlag === 3) {
                complainFlag = this.$i18n.t('lang.lab_paperecommend')
              }
              // 判断工单属性
              if (this.tableData[i].property === 0) {
                property = this.$i18n.t('lang.lab_property0Abbr')
              } else if (this.tableData[i].property === 1) {
                property = this.$i18n.t('lang.lab_property1Abbr')
              } else if (this.tableData[i].property === 2) {
                property = this.$i18n.t('lang.lab_property2Abbr')
              } else if (this.tableData[i].property === 3) {
                property = this.$i18n.t('lang.lab_property3Abbr')
              } else if (this.tableData[i].property === 4) {
                property = this.$i18n.t('lang.lab_property4Abbr')
              }
              if (this.tableData[i].isOvertime === 1) {
                property =
                  property + ',' + this.$i18n.t('lang.lab_isOvertime1Abbr')
              }
              if (this.tableData[i].state === 5) {
                property = property + ',' + this.$i18n.t('lang.lab_state5Abbr_1')
              }
              if (this.tableData[i].isFollow === 2) {
                property =
                  property + ',' + this.$i18n.t('lang.lab_isFollow2Abbr')
              }
              // if (this.tableData[i].isCheck === 1) {
              //   property = property + ',' + this.$i18n.t('lang.lab_isCheck1Abbr')
              // } else if (this.tableData[i].isCheck === 2) {
              //   property = property + ',' + this.$i18n.t('lang.lab_isCheck2Abbr')
              // }
              if (this.tableData[i].haveChild === 1) {
                property =
                  property + ',' + this.$i18n.t('lang.lab_haveChild1Abbr')
              }

              if (this.tableData[i].state === 6) {
                property =
                  property + ',' + this.$i18n.t('lang.lab_state6Abbr_1')
              }
              if (this.tableData[i].isValet === 1) {
                property =
                  property + ',' + this.$i18n.t('lang.lab_isValet1Abbr')
              }
              if (this.tableData[i].isInspect === 1) {
                property =
                  property + ',' + this.$i18n.t('lang.lab_isInspect1Abbr')
              }
              if (this.tableData[i].isCopyToMe === 1) {
                property =
                  property + ',' + this.$i18n.t('lang.lab_isCopyToMe1Abbr')
              }
              if (this.tableData[i].parentId) {
                property =
                  property + ',' + this.$i18n.t('lang.lab_haveParentIdAbbr')
              }
              // 判断工单状态
              if (this.tableData[i].state === 0) {
                state = this.$i18n.t('lang.lab_paperereportingstate')
              } else if (this.tableData[i].state === 1) {
                state = this.$i18n.t('lang.lab_papereconfirmed')
              } else if (this.tableData[i].state === 2) {
                state = this.$i18n.t('lang.lab_paperesolved')
              } else if (this.tableData[i].state === 3) {
                state = this.$i18n.t('lang.lab_paperefinsh')
              } else if (this.tableData[i].state === 4) {
                state = this.$i18n.t('lang.lab_paperealreadyevaluated')
              } else if (this.tableData[i].state === 5) {
                state = this.$i18n.t('lang.lab_paperecloses')
              } else if (this.tableData[i].state === 6) {
                state = this.$i18n.t('lang.lab_paperenoclose')
              }
              // 判断满意度
              if (this.tableData[i].evaluate === 0) {
                evaluate = this.$i18n.t('lang.lab_paperevaluateres')
              } else if (this.tableData[i].evaluate === 1) {
                evaluate = this.$i18n.t('lang.lab_paperevaluateyes')
              } else if (this.tableData[i].evaluate === 2) {
                evaluate = this.$i18n.t('lang.lab_paperevaluatesoso')
              } else if (this.tableData[i].evaluate === 3) {
                evaluate = this.$i18n.t('lang.lab_paperenovaluate')
              }
              // 判断数量
              stateCount =
                this.tableData[i].finishStateCount +
                '/' +
                this.tableData[i].errorStateCount +
                '/' +
                this.tableData[i].missStateCount +
                '/' +
                this.tableData[i].allStateCount

              newArr.push({
                id: this.tableData[i].id,
                userName: userName,
                'garden.name': gardenName,
                beginSource: beginSource,
                timestampymdhis: this.tableData[i].createTime,
                endDate: this.$options.filters.time(this.tableData[i].endDate),
                'garden.grids.houseName': houseName,
                'garden.grids.unitName': unitName,
                'garden.grids.roomName': roomName,
                'maintainType1.name': maintainType1,
                'maintainType2.name': maintainType2,
                'maintainType3.name': maintainType3,
                'maintainType4.name': maintainType4,
                complainFlag: complainFlag,
                state: state,
                property: property,
                staffId: this.tableData[i].staffId != 0 ?
                  this.tableData[i].staff.idNo : '',
                content: this.tableData[i].content,
                evaluate: evaluate,
                gardenGridName: this.tableData[i].gardenGridName,
                finishStateCount: stateCount
              })
            }
          }
          const tHeader = [
            'ID',
            '报事用户',
            '小区',
            '报事方式',
            '报事时间',
            '结束时间',
            '楼号',
            '单元号',
            '房间号',
            '报事类型',
            '报事类型II',
            '报事类型III',
            '报事类型Ⅳ',
            '事件性质',
            '工单状态',
            '工单属性',
            '接单人',
            '内容',
            '满意度',
            '管家',
            '已完成/异常/已跳过/总数量'
          ]
          const filterVal = [
            'id',
            'userName',
            'garden.name',
            'beginSource',
            'timestampymdhis',
            'endDate',
            'garden.grids.houseName',
            'garden.grids.unitName',
            'garden.grids.roomName',
            'maintainType1.name',
            'maintainType2.name',
            'maintainType3.name',
            'maintainType4.name',
            'complainFlag',
            'state',
            'property',
            'staffId',
            'content',
            'evaluate',
            'gardenGridName',
            'finishStateCount'
          ]
          excelDownload(
            tHeader,
            filterVal,
            newArr,
            '审阅&抽审问题工单'
          )
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1
      },
      // 隔行变色
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // CHECKBOX
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // 查询list
      maintains() {
        var startTs = ''
        var endTs = ''
        if (this.datevalues != null) {
          if (this.datevalues.length > 0) {
            startTs = this.datevalues[0]
            endTs = this.datevalues[1]
          }
        }
        const gardenIds = this.value.map(id => id.toString()).join(',')
        let loading = this.$loading()
        this.$get(
          `/maintains?gardenIds=${gardenIds}&maintainTypeId1=${this.firstLevelid}&pageSize=${this.pageSize}&pageNo=${this.pageNum}&state=${this.state}&startTs=${startTs}&endTs=${endTs}&checkRandomState=${this.checkRandomState}&checkState=${this.checkState}&randomState=${this.randomState}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNum = val
        if (this.handleType == 'child') {
          this.haveChildId(this.childId)
        } else {
          this.maintains()
        }
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNum = 1
        this.pageSize = val
        if (this.handleType == 'child') {
          this.haveChildId(this.childId)
        } else {
          this.maintains()
        }
      },
      // 小区下拉
      myGarden() {
        let myGardens = [...this.$store.getters.userGardenList]
        let index = myGardens.findIndex(item => item.id === 0)
        if (index != -1) {
          myGardens.splice(index, 1)
        }
        this.gardens = myGardens.map(item => ({
          ...item,
          id: item.id.toString()
        }))
      },
      // 小区下拉
      cloundGardens() {
        this.$get(`/gardens`).then(
          res => {
            if (res && res.errCode === 0) {
              res.list.unshift({
                id: '0',
                name: '请选择小区'
              })
              this.gardens = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 报事服务分类list
      maintainTypes() {
        this.$get(
          `/maintainTypes?type=${this.typeleval}&pageSize=999&pageNo=${this.pageNum}&parentId=${this.value}`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              if (this.typeleval === 1) {
                this.firstLevellist = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      commit() {
        this.pageNum = 1
        this.handleType = ''
        this.maintains()
      },
      // 操作详情
      detail(id, haveChild) {
        this.$router.push({
          name: 'questionOrderDetail',
          query: {
            id: id,
            haveChild: haveChild == 1 ? 1 : 0
          }
        })
      },
      // 详情右键跳转新链接
      jumpNewLink(id, haveChild) {
        const {
          href
        } = this.$router.resolve({
          name: 'questionOrderDetail',
          query: {
            id: id,
            haveChild: haveChild == 1 ? 1 : 0
          }
        })
        window.open(href, '_blank')
      },
      showPhotos(id) {
        this.$get(`/maintainsFileCountById/` + id).then(
          res => {
            if (res && res.errCode === 0) {
              if (res.photoCount > 0) {
                this.showPhotoBefore(id)
              } else {
                this.$message.error(this.$i18n.t('lang.lab_noPhotoCount'))
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 处理前照片 
      showPhotoBefore(id) {
        this.editId = id
        this.show = true
        let loading = this.$loading()
        this.$get(`/maintainsFile/` + id + '/1').then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.uris = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
        this.showPhotoAfter(id)
      },
      // 处理后照片
      showPhotoAfter(id) {
        this.editId = id
        this.show = true
        let loading = this.$loading()
        this.$get(`/maintainsFile/` + id + '/2').then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.uris_af = res.list
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      },
      // 工单评价等级显示
      showSetting(row) {
        this.gradeRadio = '0'
        this.gradeRemark = ''
        this.settingDialogVisible = true
        this.maintainId = row.id
        if (row.setUp != '' && row.setUp != undefined) {
          this.gradeRadio = row.setUp + ''
        }
        this.gradeRemark = row.annotation
      },
      // 工单评价等级确定
      settingConfim() {
        if (this.gradeRemark.trim() == '' && this.gradeRadio !== '0') {
          this.$message.error('请输入工单等级评价批注')
        } else {
          this.settingDialogVisible = false
          let loading = this.$loading()
          let param = {
            SetUp: this.gradeRadio,
            Annotation: this.gradeRemark
          }
          this.$post(`/saveSettingConfirm/` + this.maintainId, param).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.maintains()
              }
            },
            error => {
              loading.close()
              this.$message.error(error)
            }
          )
        }
      },
      // 工单评价等级取消
      settingCancel() {
        this.settingDialogVisible = false
      },
    }
  }
</script>

<style lang="scss">
  .newspaperInfoList {
    .el-range-editor.el-input__inner {
      width: 370px;
    }

    .filters {
      padding: 5px 20px;
    }

    .m-0 {
      margin: 0;
    }

    .filters .telidcon .el-input__inner {
      width: 180px;
    }

    .el-collapse-item__header {
      border-bottom: 0px;
    }

    .el-collapse {
      border-top: 0px;
    }

    .property0style {
      border: 1px solid#CD69C9;
      color: #cd69c9;
    }

    .property1style {
      border: 1px solid#00FF00;
      color: #00ff00;
    }

    .property2style {
      border: 1px solid#CD950C;
      color: #cd950c;
    }

    .property3style {
      border: 1px solid#CD2990;
      color: #cd2990;
    }

    .property4style {
      border: 1px solid#66DAFF;
      color: #66daff;
    }

    .isOvertime1style {
      margin-left: 2px;
      border: 1px solid#FF0000;
      color: #ff0000;
    }

    .state5style {
      margin-left: 2px;
      border: 1px solid#E7003E;
      color: #e7003e;
    }

    .state6style {
      margin-left: 2px;
      border: 1px solid#E7003E;
      color: #e7003e;
    }

    .isFollow2style {
      margin-left: 2px;
      border: 1px solid#FF9900;
      color: #ff9900;
    }

    .isCheck0style {
      margin-left: 2px;
      border: 1px solid#8C8C8C;
      color: #8c8c8c;
    }

    .isCheck1style {
      margin-left: 2px;
      border: 1px solid #67C23A;
      color: #67C23A;
    }

    .isCheck2style {
      margin-left: 2px;
      border: 1px solid#E7003E;
      color: #E7003E;
    }

    .isValet1style {
      margin-left: 2px;
      border: 1px solid #8b00ff;
      color: #8b00ff;
    }

    .isInspect1style {
      margin-left: 2px;
      border: 1px solid #555555;
      color: #555555;
    }

    .isCopyToMe1style {
      margin-left: 2px;
      border: 1px solid #87ceff;
      color: #87ceff;
    }

    .haveChild1style {
      margin-left: 2px;
      border: 1px solid #4682b4;
      background-color: #4682b4;
      color: #ffffff;
      cursor: pointer;
    }

    .haveParentIdstyle {
      margin-left: 2px;
      border: 1px solid #668b8b;
      background-color: #668b8b;
      color: #ffffff;
      cursor: pointer;
    }

    .conctentstyle {
      color: #4a88b0;
    }

    .operation {
      margin-right: 0px;
    }
  }

  .el-tooltip__popper.is-light {
    max-width: 300px;
  }

  .img {
    width: 50px;
    height: 50px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin-right: 20px;
  }

  .gradeRadio {
    padding: 10px 20px;
  }

  .gradeRadioLabel {
    margin-right: 20px;
  }

  .gradeRemarkBox {
    display: flex;
    padding: 10px 20px;
  }

  .gradeRemark {
    padding: 10px;
    box-sizing: border-box;
  }

  .gradeStar {
    margin-top: 15px;
    color: red;
  }

  .w220 {
    width: 220px !important;
  }
</style>